export class InvalidConfigurationError extends Error {
  public name = 'InvalidConfigurationError';
}
